var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49997 12.0002C8.49951 12.2628 8.55096 12.5229 8.65135 12.7655C8.75175 13.0082 8.89911 13.2286 9.08497 13.4142L14.379 18.7072L15.793 17.2932L10.5 12.0002L15.793 6.70715L14.379 5.29315L9.08597 10.5862C8.89993 10.7716 8.75238 10.992 8.65181 11.2347C8.55125 11.4773 8.49964 11.7375 8.49997 12.0002Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.8b7731a5f7b7b9ecddb49b5d9a9eb61f.svg";
export { ForwardRef as ReactComponent };